/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{getMetersPerUnitForSR as o}from"../../core/units.js";import r from"../../geometry/support/MeshTransform.js";function t(t){const e=1/o(t,1);return 1!==e?new r({scale:[e,e,e]}):void 0}export{t as getMeshTransformForMetersToSpatialReference};
